import VueRouter, { NavigationGuardNext, Route } from "vue-router"

import Dashboard from "../views/Dashboard.vue"
import Login from "../views/Login.vue"
import SignUp from "../views/Signup.vue"
import Account from "../views/Account.vue"
import Search from "../views/Search.vue"
import UserProfile from "../views/UserProfile.vue"
import Organization from "../views/Organization.vue"
import { hasPermission, setApiCacheSkip } from "./guards"

const routes = [
	{
		path: "/",
		name: "home",
		meta: {
			icon: "fa-home"
		},
		redirect: "/login"
	},
	{
		path: "/login",
		name: "login",
		component: Login,
		meta: {
			allowAnon: true,
			forceTheme: true
		}
	},
	{
		path: "/signup",
		name: "signup",
		component: SignUp,
		meta: {
			allowAnon: true,
			icon: "fas fa-user-plus",
			breadcrumb: "Signup"
		}
	},
	{
		path: "/dashboard",
		name: "dashboard",
		component: Dashboard,
		meta: {
			icon: "fas fa-tachometer-alt",
			breadcrumb: "Dashboard",
			allowApiCache: true
		}
	},
	{
		path: "/cases",
		name: "overview",
		component: () => import("@/views/CasesOverview.vue"),
		meta: {
			icon: "fa-newspaper",
			breadcrumb: "Overview",
			allowApiCache: true
		}
	},
	{
		path: "/cases/:caseNumber",
		name: "case",
		component: () => import("@/views/CaseDetails.vue"),
		meta: {
			breadcrumb: "Case",
			allowApiCache: true
		}
	},
	{
		path: "/cases/restricted/:caseNumber",
		name: "restricted-cases",
		component: () => import("@/views/RestrictedCaseDetails.vue"),
		meta: {
			breadcrumb: "Restricted Cases",
			allowApiCache: true
		}
	},
	{
		path: "/account",
		name: "account",
		component: Account,
		meta: {
			breadcrumb: "Account"
		}
	},
	{
		path: "/configuration",
		name: "configuration",
		component: () => import("@/views/Configuration.vue"),
		meta: {
			icon: "fa-cog",
			breadcrumb: "Configuration"
		}
	},
	{
		path: "/users",
		name: "users",
		component: () => import("@/views/Users.vue"),
		beforeEnter: (to: Route, from: Route, next: NavigationGuardNext) => hasPermission(to, from, next, "editData"),
		meta: {
			icon: "fa-cog",
			breadcrumb: "Users",
			allowApiCache: true
		}
	},
	{
		path: "/insights",
		name: "insights",
		component: () => import("@/views/Insights.vue"),
		meta: {
			icon: "fa-cog",
			breadcrumb: "Insights",
			allowApiCache: true
		}
	},
	{
		path: "/integrations",
		name: "integrations",
		component: () => import("@/views/Integrations.vue"),
		meta: {
			icon: "fa-cog",
			breadcrumb: "Integrations",
			allowApiCache: true
		}
	},
	{
		path: "/scheduling",
		name: "scheduling",
		component: () => import("@/views/Scheduling.vue"),
		beforeEnter: (to: Route, from: Route, next: NavigationGuardNext) => hasPermission(to, from, next, "scheduling"),
		meta: {
			icon: "fa-calendar",
			breadcrumb: "Scheduling",
			allowApiCache: true
		}
	},
	{
		path: "/userprofile/:userId",
		name: "userprofile",
		component: UserProfile,
		meta: {
			icon: "fa-cog",
			breadcrumb: "User Profile",
			allowApiCache: true
		}
	},
	{
		path: "/organization",
		name: "organization",
		component: Organization,
		meta: {
			icon: "fa-cog",
			breadcrumb: "Organization"
		}
	},
	{
		path: "/search",
		name: "search",
		component: Search,
		meta: {
			icon: "fa-cog",
			breadcrumb: "Search",
			allowApiCache: true
		}
	},
	{
		path: "/system",
		name: "system",
		component: () => import("@/views/System.vue"),
		meta: {
			icon: "fa-cog",
			breadcrumb: "System"
		}
	},
	{
		// handle a non-existing route - redirect to root route
		path: "*",
		redirect: "/login"
	}
]

const router = new VueRouter({
	base: process.env.BASE_URL,
	routes
})

// Register global navigation guards
router.beforeEach(setApiCacheSkip)

export default router
